import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Users, Building2, BadgeCheck, Shield, ScrollText, ShieldAlert, RefreshCw, AlertTriangle, TrendingUp, Wallet } from "lucide-react";
import api from "@/lib/api";
import DashboardShell from "@/components/layout/DashboardShell";
import { adminMenu } from "@/config/menus";
import { KpiCard, PageHeader } from "@/components/KpiCard";
import { Button } from "@/components/ui/button";
import { LoadingScreen, inr } from "@/components/common";

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  return (
    <DashboardShell menu={adminMenu} title="Marketplace Control Centre">
      <PageHeader title="Platform Overview" subtitle="Real-time marketplace KPIs and health." />
      {!d ? <LoadingScreen /> : (
        <div className="space-y-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <KpiCard icon={Users} label="Total Customers" value={d.total_customers} testid="kpi-customers" />
            <KpiCard icon={Building2} label="Total Agencies" value={d.total_agencies} testid="kpi-agencies" />
            <KpiCard icon={BadgeCheck} label="Verified Agencies" value={d.verified_agencies} accent testid="kpi-verified" />
            <KpiCard icon={Shield} label="Total Guards" value={d.total_guards} testid="kpi-guards" />
            <KpiCard icon={ScrollText} label="Active Contracts" value={d.active_contracts} testid="kpi-contracts" />
            <KpiCard icon={ShieldAlert} label="Pending Verification" value={d.pending_verification} testid="kpi-pending-ver" />
            <KpiCard icon={RefreshCw} label="Replacement Requests" value={d.replacement_requests} testid="kpi-replacements" />
            <KpiCard icon={AlertTriangle} label="Open Complaints" value={d.open_complaints} testid="kpi-complaints" />
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="bg-navy-900 text-white rounded-xl p-6">
              <div className="flex items-center gap-2 brand-label text-brand"><TrendingUp size={14} /> Monthly GMV</div>
              <div className="font-heading text-4xl font-extrabold mt-2">{inr(d.monthly_gmv)}</div>
              <p className="text-navy-400 text-sm mt-1">Gross merchandise value processed on the platform.</p>
            </div>
            <div className="bg-brand rounded-xl p-6 text-white">
              <div className="flex items-center gap-2 brand-label text-white/80"><Wallet size={14} /> Platform Revenue</div>
              <div className="font-heading text-4xl font-extrabold mt-2">{inr(d.platform_revenue)}</div>
              <p className="text-white/80 text-sm mt-1">Commission earned from facilitated contracts.</p>
            </div>
          </div>
          <div className="flex flex-wrap gap-3">
            <Button className="bg-navy-900 hover:bg-navy-800" onClick={() => navigate("/admin/verification")}>Review Verifications ({d.pending_verification})</Button>
            <Button variant="outline" className="border-navy-300" onClick={() => navigate("/admin/analytics")}>View Analytics</Button>
            <Button variant="outline" className="border-navy-300" onClick={() => navigate("/admin/settings")}>Marketplace Settings</Button>
          </div>
        </div>
      )}
    </DashboardShell>
  );
}
